import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import wrongTurnAlertsSrc from './images/wrong-turn-alerts-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const wrongTurnAlerts = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Wrong-Turn Alerts' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Get alerts if you go off route' }),
  thumbnailImage: wrongTurnAlertsSrc.src
});

export default wrongTurnAlerts;
